import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { MobileComponent } from "../../../mobile/interface/mobile.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "rfc-text-subtext-column",
  templateUrl: "./text-subtext-column.component.html",
  styleUrls: ["./text-subtext-column.component.scss"],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class TextSubtextColumnComponent
  extends MobileComponent
  implements OnChanges
{
  @Input() textSubText;
  constructor() {
    super();
  }

  ngOnChanges() {}
}
